import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'
import { deleteProjectStatus, fetchProjectStatus, upsertProjectStatus } from '@/api/projectStatus'
import type { ProjectStatusDeletePayload, ProjectStatusUpsertPayload } from '@/types/projectStatus'

export function useProjectStatus(clientId: string) {
  return useQuery({
    queryKey: queryKeys.projectStatus.detail(clientId),
    queryFn: () => fetchProjectStatus(clientId),
    enabled: !!clientId,
  })
}

export function useUpsertProjectStatusMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: ProjectStatusUpsertPayload) => upsertProjectStatus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projectStatus.detail(clientId) })
    },
  })
}

export function useDeleteProjectStatusMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: ProjectStatusDeletePayload) => deleteProjectStatus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projectStatus.detail(clientId) })
    },
  })
}
